const PERMISSION_KEY= "company:se_index_snapshot";
const PAGE_URL = {
    SE_INDEX_SNAPSHOT_PAGE: "/admin/company/se-index-snapshot"
}

export {PERMISSION_KEY, PAGE_URL}

